module.exports = __webpack_public_path__ + "src/img/right.83698683.svg";